export const Spicy = 'Spicy';
export const Recommended = 'Recommended';
export const Vegetable = 'Vegetable';
export const Chicken = 'Chicken';
export const Pork = 'Pork';
export const Beef = 'Beef';
